import { Component } from "react";

import Header from "../components/Header/Header";
import Info from "../components/Info/Info";
import SolarSystem from "../components/SolarSystem/SolarSystem";

export default class HomeView extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="home">
        <Header />

        <div className="container">
          <SolarSystem />

          <Info />
        </div>
      </div>
    );
  }
}
